module.exports = __webpack_public_path__ + "img/icon-06.706bd069.png";